import EncryptInput from "../helper/EncryptInput";
import FormatAmount from "../helper/FormatAmount";

export const getSearchData = (valObj) => {
  let newBinsList = valObj["bins"] || [];
  let convertedAmount = Number(valObj["amount"]);
  let convertedDiscount = Number(valObj["discount"]) || 0;

  let tempMoney =
    newBinsList.length > 0
      ? Number((convertedAmount + convertedDiscount).toFixed(2))
      : Number((convertedAmount + convertedDiscount).toFixed(2));

  const searchData = {
    // On the success/failure landing (/api/v2/payment/auth) these come back under
    // different keys — fall back so txnId/tid still populate. (Resume keeps the real
    // launch values via write-once identity merge in analytics.)
    transactionID: valObj["uniqeTransactionid"] || valObj["invoiceNumber"],
    amount: convertedAmount,
    totalAmount: tempMoney,
    discount: convertedDiscount,
    swinkpayID: valObj["transactionId"],
    currency: valObj["currency"],
    tax: valObj["tax"],
    mid: valObj["mid"],
    tid: valObj["tid"] || valObj["terminalID"],
    token: valObj["token"],
    txnid: valObj["txnid"],
    logo: valObj["logo"],
    color: valObj["colour"],
    datakey: valObj["datakey"],
    returnURL: valObj["returnURL"],
    // merReturnURL: full merchant callback URL (with query params). Kept as its own field
    // so it can be sent to the QR API and used for the post-completion redirect.
    merReturnURL: valObj["merReturnURL"] || null,
    divid: valObj["divid"],
    pg: parseInt(valObj["pg"]),
    cardPG: parseInt(valObj["cardPG"]),
    upiPG: parseInt(valObj["upiPG"]),
    date: valObj["date"],
    statusCode: parseInt(valObj["statusCode"]),
    merchantName: valObj["name"],
    refnum: valObj["refnum"],
    bins: valObj["bins"] || [],
    card: valObj["card"],
    netbanking: valObj["netbanking"],
    wallet: valObj["wallet"],
    upiDQR: valObj["upiDQR"],
    upiCollect: valObj["upiCollect"],
    verifyUPICollect: valObj["verifyUPICollect"],
    upiDeepLink: valObj["upiDeepLink"],
    onlyCardBins: valObj["onlyCardBins"] || false,
    backURL: valObj["backURL"] || null,
    remarks: valObj["remarks"] || "",
    // Pre-known payer details the data API may return (any/all can be blank). When a valid
    // userMobile is present the Contact Details screen is skipped and these are auto-filled.
    // All four are forwarded to the firstleg + QR APIs under these SAME keys.
    userName: valObj["userName"] || "",
    userMobile: (valObj["userMobile"] || "").toString().replace(/\D/g, "").slice(0, 10),
    userEmail: valObj["userEmail"] || "",
    userAddress: valObj["userAddress"] || "",
    // Payment offers returned inline by the data API; drives the Available Offers strip.
    offers: valObj["offers"] || [],
    // Post-payment rewards page URL (success screen). When non-null it's embedded in the
    // success hero area; null → the default success UI is shown.
    rewardsURL: valObj["rewardsURL"] || null,
    // Custom logo shown top-left in the header. When present it's used instead of the merchant's
    // own logo (merchant_logo). Optional; the header always renders the white layout either way.
    // The "Powered by <name>" text on the right comes from merchantName (the `name` key).
    customLogoBannerUrl: valObj["customLogoBannerUrl"] || null,
    // Compliance disclaimer text shown as a note at the bottom of the payment card.
    disclaimerNote: valObj["disclaimerNote"] || "",
  };

  return searchData;
};

export const getFirstLegData = (data, formData) => {
  const enc_data = EncryptInput(data, formData);

  const firstlegdata = {
    merchantId: data["mid"], //data["mid"],  //"0000000000052415",
    terminalId: data["tid"],
    flyerMobile: data["customerMobile"] || "",
    // Payer details forwarded under the SAME keys the data API returns them. userMobile falls
    // back to the number entered on the Contact Details screen (customerMobile).
    userName: data["userName"] || "",
    userMobile: data["customerMobile"] || data["userMobile"] || "",
    userEmail: data["customerEmail"] || data["userEmail"] || "",
    userAddress: data["userAddress"] || "",
    amount: FormatAmount(data["totalAmount"]),
    discount: FormatAmount(data["discount"]),
    tax: data["tax"],
    message: "",
    currency: data["currency"],
    cardRefToken: enc_data.cardRefNumber, // For payU: RSA
    data1: enc_data.salt, // salt
    data2: enc_data.delimiter, // delimiter
    data: formData?.upiID || "",
    modeofpayment: formData?.modeOfPayment,
    bankID: formData?.bank?.bankID || formData?.bankID || "",
    userAgent: "firefox",
    additionalData: data?.pg === 10 ? "WebPlugin" : "",
    retrunURL: data["refnum"],
    billNumber: data?.transactionID, // Invoice number
    cardId: "0",
    referenceId: "245454", // Random number
    paymentStatus: "PayU Transaction",
    data3: formData?.upiID || "",
    cVPA: formData?.upiID || "",
    consumerToken: "",
    storeCard: "0",
    lrTransactionId: "",
    clientIPAddress: "192.168.1.3",
    payUToken: "",
    token: enc_data.delimiter, // Plain seperator.
    returnURL: data["refnum"], // For PayU only
  };

  return firstlegdata;
};

export const TESTING_CARDS = [
  { cardNumber: "4706131211212123", binNum: "47061312", scheme: "visa" },
  { cardNumber: "4062288312345026", binNum: "40622883", scheme: "visa" },
  { cardNumber: "4576238912771450", binNum: "45762389", scheme: "visa" },
  { cardNumber: "4444333322221111", binNum: "44443333", scheme: "visa" },
  { cardNumber: "4466050254381183", binNum: "44660502", scheme: "visa" },
  { cardNumber: "4136880012657791", binNum: "41368800", scheme: "visa" },
  { cardNumber: "4074970084343075", binNum: "40749700", scheme: "visa" },
  { cardNumber: "4770355457382883", binNum: "47703554", scheme: "visa" }, //visa ends here
  { cardNumber: "6521660116138452", binNum: "652166", scheme: "visa" }, //easybuzz visa
  { cardNumber: "4111111111111111", binNum: "41111111", scheme: "visa" },

  { cardNumber: "5409162669381034", binNum: "54091626", scheme: "mastercard" },
  { cardNumber: "5445856839524391", binNum: "54458568", scheme: "mastercard" },
  { cardNumber: "5105105105105100", binNum: "51051051", scheme: "mastercard" },
  { cardNumber: "5176539438527826", binNum: "51765394", scheme: "mastercard" },
  { cardNumber: "5242535837492075", binNum: "52425358", scheme: "mastercard" },
  { cardNumber: "5203860658394375", binNum: "52038606", scheme: "mastercard" },
  { cardNumber: "5552190758372734", binNum: "55521907", scheme: "mastercard" },
  { cardNumber: "5506908329471983", binNum: "55069083", scheme: "mastercard" }, //mastercard ends here

  { cardNumber: "6074825972083818", binNum: "60748259", scheme: "rupay" },
  { cardNumber: "6074828163369590", binNum: "60748281", scheme: "rupay" },
  { cardNumber: "6528591234543575", binNum: "65285912", scheme: "rupay" },
  { cardNumber: "65292523412356", binNum: "65292523", scheme: "rupay" },
];

export const CARD_TYPES = [
  { key: 1, id: "dc", name: "Debit" },
  { key: 2, id: "cc", name: "Credit" },
];
